module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 84);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/component");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ dialog_Dialog; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(8);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(6);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(9);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@tencent/txv-utils"
var txv_utils_ = __webpack_require__(1);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/component"
var component_ = __webpack_require__(12);
var component_default = /*#__PURE__*/__webpack_require__.n(component_);

// CONCATENATED MODULE: ./src/comps/common/dialog/template.js
var dialogTpl = function dialogTpl(ops) {
  var type = ops.type,
    className = ops.className,
    title = ops.title,
    body = ops.body,
    footer = ops.footer,
    append = ops.append,
    showClose = ops.showClose,
    closeOnClickModal = ops.closeOnClickModal,
    screen = ops.screen;
  return "\n    <div class=\"mod-dialog-wrapper\" data-close=\"".concat(closeOnClickModal, "\">\n      <div class=\"mod-dialog \n        ").concat(className, " \n        ").concat(type ? "mod-dialog--".concat(type) : '', "\"\n        role=\"dialog\"\n        ref=\"dialog\">\n        <div class=\"mod-dialog-header\">\n          ").concat(title, "\n        </div>\n        <div class=\"mod-dialog-body\">\n          <div class=\"dialog-body-inner\">\n            ").concat(body, "\n          </div>\n        </div>\n        <div class=\"mod-dialog-footer\">\n          ").concat(footer, "\n        </div>\n        ").concat(showClose && screen !== 'mini' ? "<div class=\"mod-dialog-close\" data-close=\"true\">\n          <i class=\"athena-dialog-close-icon\" data-close=\"true\">\n            <svg data-close=\"true\" class=\"athena_svg_icon\" viewBox=\"0 0 30 30\" width=\"30\" height=\"30\">\n              <path d=\"M16.1 15L24 7.1c.1-.1.2-.3.2-.5s-.1-.4-.2-.6c-.3-.3-.8-.3-1.1 0L15 13.9 7.1 6c-.3-.3-.8-.3-1.1 0-.1.2-.2.4-.2.6s.1.3.2.5l7.9 7.9L6 22.9c-.1.1-.2.3-.2.5s.1.4.2.6c.3.3.8.3 1.1 0l7.9-7.9 7.9 7.9c.1.1.3.2.5.2s.4-.1.5-.2.2-.3.2-.5-.1-.4-.2-.5l-7.8-8z\"></path>\n            </svg>\n          </i>\n        </div>" : '', "\n        \n        <!--\u540E\u7F6E\u5143\u7D20-->\n        <div class=\"mod-dialog-append\">").concat(append, "</div>\n        ").concat(showClose && screen === 'mini' ? "<div class=\"mod-dialog-mini-close\" data-close=\"true\">\n          \u70B9\u51FB\u5173\u95ED\u5F39\u7A97\n        </div>" : '', "\n      </div>\n    </div>\n  ");
};
/* harmony default export */ var template = (dialogTpl);
// CONCATENATED MODULE: ./src/comps/common/dialog/index.js





function _callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @Author ivytang
 * @Date 2020/1/11
 * @Desc 弹窗公共组件
 * @Param {Number} [width] - 弹窗宽度
 * @Param {String} [title] - 弹窗头部
 * @Param {String} [body] - 弹窗内容
 * @Param {String} [footer] - 弹窗底部
 * @Param {Boolean} [showClose] - 是否展示关闭按钮
 * @Param {Boolean} [lockScroll] - 是否锁定背景滚动，默认不锁定
 * @Param {Boolean} [closeOnClickModal] - 是否可以通过点击遮罩层关闭Dialog
 **/



var dialog_Dialog = /*#__PURE__*/function (_Component) {
  function Dialog(containerId, options) {
    var _this;
    classCallCheck_default()(this, Dialog);
    _this = _callSuper(this, Dialog, [containerId, options]);
    _this.eventHub = txv_utils_["EventHub"].createEvents(_this);
    _this.lockScroll = !!(options && options.lockScroll);
    _this.init();
    _this.initAction();
    if (_this.lockScroll) {
      _this.addOverflowHidden();
    }
    return _this;
  }
  inherits_default()(Dialog, _Component);
  return createClass_default()(Dialog, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.initAction = Object(txv_utils_["once"])(function () {
        _this2.$containerDom.on('click', function (e) {
          var close = e.target.dataset.close;
          if (close === 'true') {
            _this2.eventHub.fire('cancel', _this2.options);
            _this2.close();
          }
        });
      });
    }
  }, {
    key: "addOverflowHidden",
    value: function addOverflowHidden() {
      document.body.classList.add('iwan-overflow-hidden');
    }
  }, {
    key: "removeOverflowHidden",
    value: function removeOverflowHidden() {
      document.body.classList.remove('iwan-overflow-hidden');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$options = this.options,
        _this$options$title = _this$options.title,
        title = _this$options$title === void 0 ? '' : _this$options$title,
        _this$options$body = _this$options.body,
        body = _this$options$body === void 0 ? '' : _this$options$body,
        _this$options$footer = _this$options.footer,
        footer = _this$options$footer === void 0 ? '' : _this$options$footer,
        _this$options$append = _this$options.append,
        append = _this$options$append === void 0 ? '' : _this$options$append,
        _this$options$classNa = _this$options.className,
        className = _this$options$classNa === void 0 ? '' : _this$options$classNa,
        _this$options$showClo = _this$options.showClose,
        showClose = _this$options$showClo === void 0 ? true : _this$options$showClo,
        _this$options$closeOn = _this$options.closeOnClickModal,
        closeOnClickModal = _this$options$closeOn === void 0 ? false : _this$options$closeOn;
      var _urlToJson = Object(txv_utils_["urlToJson"])(),
        screen = _urlToJson.screen;
      return template({
        title: title,
        body: body,
        footer: footer,
        append: append,
        className: className,
        showClose: showClose,
        closeOnClickModal: closeOnClickModal,
        screen: screen
      });
    }

    /**
       * 获取dialog 部分dom
       */
  }, {
    key: "$header",
    get: function get() {
      return this.$containerDom.find('.mod-dialog-header');
    }
  }, {
    key: "$body",
    get: function get() {
      return this.$containerDom.find('.mod-dialog-body');
    }
  }, {
    key: "$bodyInner",
    get: function get() {
      return this.$containerDom.find('.dialog-body-inner');
    }
  }, {
    key: "$footer",
    get: function get() {
      return this.$containerDom.find('.mod-dialog-footer');
    }
  }, {
    key: "$append",
    get: function get() {
      return this.$containerDom.find('.mod-dialog-append');
    }
  }, {
    key: "beforeClose",
    value: function beforeClose() {
      return true;
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.beforeClose()) {
        return;
      }
      this.eventHub.fire('close', this.options);
      this.destroy();
      if (this.lockScroll) {
        this.removeOverflowHidden();
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.$containerDom.toggle();
      var isHidden = this.$containerDom.css('display') === 'none';
      if (isHidden && this.lockScroll) {
        this.removeOverflowHidden();
      }
    }
  }]);
}(component_default.a);


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ })

/******/ })["default"];